import React, { useEffect, useState } from "react";
import Header from "../../../component/menu/Header";
import CustomLoader from "../../../component/menu/CustomLoader";
import { SettingOutlined, } from "@ant-design/icons";
import CouponAddOrEdit from "../../../component/coupon/CouponAddOrEdit";
import { Button, ConfigProvider } from "antd";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../utils/ApiService";
import useUserStore from "../../../stores/store";
import { useParams } from "react-router-dom";

export default function CouponEdit() {
    const { showNotification, setNetworkCall, user } = useUserStore();
    const [isRelaunch, setIsRelaunch] = useState(String(window.location.href).includes('relaunch'));
    const [editData, setEditData] = useState(null);
    const navigate = useNavigate();
    const { couponId } = useParams();

    async function getCouponDetail(couponId) {
        setNetworkCall(true);
        try {
            const res = await ApiService.GET_COUPON_DETAIL(couponId, user.token.token);
            if (res.code !== 200) {
                showNotification(res.data.message);
                setNetworkCall(false);
                return;
            }

            const record = res.payload.record;
            setEditData({ ...record });
            setNetworkCall(false);
        } catch (err) {
            showNotification(err.response.data.message);
            setNetworkCall(false);
            return;
        }
    }

    useEffect(() => {
        if (Boolean(couponId)) {
            getCouponDetail(couponId);
        }

    }, [couponId]);

    return (
        <div className="flex flex-col min-h-screen bg-gray-50">
            <CustomLoader />
            <Header title={"Coupon Settings"} /> {/* Assuming you keep existing header */}

            <div className="flex flex-col p-[24px] w-full mt-[80px] font-uregular">
                <div className="w-[80%] m-auto bg-white shadow-lg rounded-lg overflow-hidden">

                    {/* Header Section */}
                    <div className="p-5 border-b flex justify-between items-center">
                        <div className="font-bold text-lg flex items-center">
                          {isRelaunch ? "Relaunch Coupon": "Edit Coupon"}
                        </div>

                        <ConfigProvider
                            theme={{
                                token: {
                                    colorPrimary: "#FCBD10",
                                },
                            }}
                        >
                            <ConfigProvider
                                theme={{
                                    token: {
                                        colorPrimary: "#FCBD10",
                                        colorPrimaryHover: "#FCBD10",
                                        colorPrimaryActive: "#FCBD10",
                                        colorTextLightSolid: "#000000",
                                    },
                                }}
                            >
                                <Button className="text-black font-semibold h-[48px] mr-1" type="primary" onClick={() => navigate('/coupon-settings')}>
                                    List
                                </Button>
                            </ConfigProvider>
                        </ConfigProvider>

                    </div>

                    {/* Body Section */}
                    <div className="p-5">
                        {
                            Boolean(editData) && (
                                <CouponAddOrEdit
                                    editData={editData}
                                    isEdit={true}
                                    isRelaunch={isRelaunch}
                                />
                            )
                        }
                    </div>

                </div>
            </div>
        </div>
    );
}